import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { InputOTP, InputOTPSlot } from "@/components/ui/input-otp";
import { Link, useLocation, useNavigate } from "react-router";
import Logo from "../../assets/texpress.png";
import { useState } from "react";

const ResetCode = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  return (
    <div className="flex flex-col items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col gap-6 items-center">
        <Link to="/">
          <img src={Logo} className="h-10" />
        </Link>
        <Card className="w-full lg:w-[448px] p-6">
          <CardHeader className="text-center lg:w-[408px] mx-auto">
            <CardTitle className="text-2xl font-medium">
              Enter reset code
            </CardTitle>
            <CardDescription>
              We have sent a code to your email address, please enter the code
              to proceed
            </CardDescription>
          </CardHeader>
          <CardContent>
            {/* <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}> */}
            <div className="grid gap-6">
              {/* <FormField
                    control={form.control}
                    name="otp"
                    render={({ field }) => {
                      return (
                        <FormItem>
                          <FormControl> */}
              <InputOTP
                maxLength={6}
                onChange={(e) => setCode(e)}
                className="flex justify-between gap-8"
              >
                <InputOTPSlot index={0} className=" w-14 h-14" />
                <InputOTPSlot index={1} className=" w-14 h-14" />
                <InputOTPSlot index={2} className="w-14 h-14" />
                <InputOTPSlot index={3} className=" w-14 h-14" />
                <InputOTPSlot index={4} className=" w-14 h-14" />
                <InputOTPSlot index={5} className="w-14 h-14" />
              </InputOTP>
              {/* </FormControl>
                        </FormItem>
                      );
                    }}
                  /> */}

              <Button
                // type="submit"
                variant="default"
                className="w-full bg-gradient-to-r from-primary to-primary-2 h-14 rounded-[10px] p-[10px]"
                disabled={code?.length <= 0 || code?.length < 6}
                onClick={() =>
                  navigate("/reset-password", {
                    state: {
                      code,
                      email: location?.state?.email,
                    },
                  })
                }
              >
                {/* {mutation.isPending && (
                      <Loader2 className="text-white animate-spin" />
                    )} */}
                Confirm
              </Button>
            </div>
            {/* </form>
            </Form> */}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ResetCode;
